var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.header }, [
    _c("div", { class: _vm.$style.headerContainer }, [
      _c("div", { class: _vm.$style.headerLogo }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/horizontal.png"),
            alt: "Burger Boss"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.headerLogoMobile }, [
        _c("img", {
          attrs: { src: require("@/assets/img/white.png"), alt: "Burger Boss" }
        })
      ]),
      _vm._v(" "),
      _vm.user
        ? _c(
            "div",
            { class: _vm.$style.headerUserData },
            [_c("DesktopUserData")],
            1
          )
        : _c("div", { class: _vm.$style.guestTitle }, [_vm._v("GuestCheckout")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopCheckoutHeader.vue?vue&type=template&id=1ef544dd&
// module id = null
// module chunks = 